
define('jsx!components/modal/share/share-email',[
	"underscore",
	"react",
], function(_, React) {
	var ____Class0=React.Component;for(var ____Class0____Key in ____Class0){if(____Class0.hasOwnProperty(____Class0____Key)){ShareEmail[____Class0____Key]=____Class0[____Class0____Key];}}var ____SuperProtoOf____Class0=____Class0===null?null:____Class0.prototype;ShareEmail.prototype=Object.create(____SuperProtoOf____Class0);ShareEmail.prototype.constructor=ShareEmail;ShareEmail.__superConstructor__=____Class0;
		function ShareEmail(props) {"use strict";
			____Class0.call(this,props);

			_.bindAll(this,
				"renderReachedSentEmailQuota",
				"openShareEmailTab"
			);

			this.state = {};
		}

		Object.defineProperty(ShareEmail.prototype,"renderReachedSentEmailQuota",{writable:true,configurable:true,value:function() {"use strict";
			return React.createElement("div", {className: "modal-tab-area alert alert-warning"}, 
				"You have already e-mailed this Buncee ",  this.props.numSentEmails, " times. Please upgrade your account to send more."
			);
		}});

		Object.defineProperty(ShareEmail.prototype,"openShareEmailTab",{writable:true,configurable:true,value:function() {"use strict";
			var buncee = window.appData.buncee.data;
			this.props.showEmailTrackingButton();
			window.open('/dashboard#{"view":"addressbook", "buncee":"'+buncee.guid+'"}', '_blank');
		}});

		Object.defineProperty(ShareEmail.prototype,"render",{writable:true,configurable:true,value:function() {"use strict";
			var buncee = window.appData.buncee.data;

			if(buncee.privacy_level == "private") {
				return this.props.renderPrivacyLevelWarning("Only Me");
			}

			// If we have already exceeded our sent email quota, display an error message.
			var maxSentEmails = parseInt(object_get(window.appData, "user.data.settings.share.max_sent_emails_per_buncee", 10));
			if (this.state.numSentEmails >= maxSentEmails) {
				return this.renderReachedSentEmailQuota();
			}
			
			return React.createElement("div", {className: "modal-tab-area", style: {"marginTop":0,position:"relative"}}, 
				React.createElement("a", {className: "modal-button share-email", onClick: this.openShareEmailTab}, "Send an Email"), 
				
					(this.props.hasBeenEmailed) ?
					React.createElement("a", {className: "modal-button share-email", href: '/dashboard#{"view":"email-activities", "buncee":"'+buncee.guid+'"}', target: "_blank"}, "Check The Email Status") : null
				
			);
		}});
	

	ShareEmail.defaultProps = {
		numSentEmails:0,
		showEmailTrackingButton: function() { /* No-op */ }
	}

	return ShareEmail;
});
